import { render, staticRenderFns } from "./ChoosePassengerMulti.vue?vue&type=template&id=e12d8a5e&scoped=true"
import script from "./ChoosePassengerMulti.vue?vue&type=script&lang=js"
export * from "./ChoosePassengerMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12d8a5e",
  null
  
)

export default component.exports